import { render, staticRenderFns } from "./ReviewProductSearchPop.vue?vue&type=template&id=8fbeda7a&"
import script from "./ReviewProductSearchPop.vue?vue&type=script&lang=ts&"
export * from "./ReviewProductSearchPop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports